import { useEffect, useState } from 'react';
import axios from 'axios';

const useGetLocationData = (url) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedData = localStorage.getItem('locationData');

        if (storedData === null) {
          const response = await axios.get(url);
          const newData = response.data;
          setData(newData);
        } else {
          setData(JSON.parse(storedData));
        }
      } catch (error) {
        console.error('error', error);
      }
    };

    // fetchData 함수 호출
    fetchData();
  }, [url]);

  return data;
};

export default useGetLocationData;
